import { WithStyles, withStyles } from '@mui/styles';

import { muiStyles } from './styles';
import WalletCompactDetails from './WalletCompactDetails';

export interface WalletCompactDetailsProps extends WithStyles<typeof muiStyles> {
    accountName: string;
    accountNo: string;
}

export default withStyles(muiStyles)(WalletCompactDetails);